import { render } from "./AcademyView.vue?vue&type=template&id=468d38d4"
import script from "./AcademyView.vue?vue&type=script&lang=js"
export * from "./AcademyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__